import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, {memo, useMemo, useState} from 'react';
import {useTranslation} from 'react-i18next';

import ActivityItem
  from '@/modules/proposalRequest/components/ProposalActivitiesSelect/components/ActivitiesListPreview/ActivityItem';

const ActivitiesListPreview = ({value, records, onRemove, onlyRead, initialShow, removeSpace, ...rest}) => {
  const [showMore, setShowMore] = useState(initialShow === undefined);
  const {t} = useTranslation('configuration');
  
  const elementsToShow = useMemo(() => {
    if (!value) return [];
    if (!initialShow || showMore) return value;
    return value?.splice(0, initialShow);
  }, [initialShow, showMore, value]);
  
  const hasMore = useMemo(() => {
    return elementsToShow?.length < value?.length;
  }, [elementsToShow?.length, value?.length]);
  
  return (
    <div
      className={classNames({'mt-4': value?.length && !onlyRead && !removeSpace}, {'mt-2': onlyRead && !removeSpace}, {'mt-0': removeSpace})}>
      {elementsToShow?.map((element, index) => {
        const data = records[element?.id || element];
        const props = {
          onRemove: !onlyRead ? () => onRemove && onRemove(element?.id || element, index, data) : null,
          ...rest
        };
        return <ActivityItem key={index} data={data} onlyRead={onlyRead} indexKey={index}
          element={element} {...props}/>;
      })}
      <div>
        {hasMore && <div className="text-primary cursor-pointer" onClick={() => setShowMore(true)}>
          {t('showAll')}
        </div>}
      </div>
    </div>
  );
  
};

ActivitiesListPreview.propTypes = {
  value: PropTypes.any,
  initialShow: PropTypes.number,
  onlyRead: PropTypes.bool,
  removeSpace: PropTypes.bool,
  records: PropTypes.object,
  onRemove: PropTypes.func
};

ActivitiesListPreview.defaultProps = {
  records: {}
};

export default memo(ActivitiesListPreview);
